export default `
  mutation CHECKOUT($siteId: String!, $userId: String!, $location: Location!){
    checkout(siteId: $siteId, userId: $userId, location: $location){
      message
      code
    }
  }
`
